<app-quotes-subsections-toggles [activeTab]="activeTab.LNOrders" [isOnAccountsPage]="isOnAccountsPage"></app-quotes-subsections-toggles>

<!-- Desktop View -->
<div *appIsDesktop id="lnOrdersContainer" class="container">
  @if (isLoading) {
    <div id="loadingContainer" class="overlay full">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner id="lnOrdersLoader" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  <ds-paper borderRadius="radius_S" insidePaddingTop="top-spacing_L" insidePaddingBottom="bottom-spacing_L"
    insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL">

    @if (dataLoaded.templateValues) {
      <app-quotes-subsections-filter-form (resetSort)="resetSortIndicator($event)"
        (resetPage)="resetPageIndex()" [getListMethod]="getListMethod" [sortKey]="lnOrderKey"
        [label]="appStrings.menu_lnOrders" [isOnAccountsPage]="isOnAccountsPage"
        [bpNumber]="bpNumber" [lnOrderTemplates]="templateValuesResult" [activeTab]="activeTab.LNOrders">
      </app-quotes-subsections-filter-form>
    }

    <div [hidden]="!totalRecords">
      <ds-table id="orderTableList" mat-table matSort [dataSource]="orderList"
        (matSortChange)="sortData($event)" [displayedColumns]="displayedColumns" [isWithRadio]="isWithRadio">
        <ng-container matColumnDef="salesRepresentative">
          <th id="orderSalesRepresentative" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ appStrings.invoiceDetails_salesRepresentative }}
          </th>
          <td [id]="'salesRepresentative_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            {{ order.accountManagerName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th id="customerName" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ appStrings.invoiceDetails_name }}
          </th>
          <td [id]="'customerName_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            {{ order.accountName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="orderNumber">
          <th id="orderNumber" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ appStrings.orderDetails_orderNumber }}
          </th>
          <td [id]="'orderNumber_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            {{ order.orderNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="orderDate">
          <th id="orderDate" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ appStrings.orderDetails__orderDate }}
          </th>
          <td [id]="'orderDate_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            {{ order.orderDate | date: dateFormat }}
          </td>
        </ng-container>
        <ng-container matColumnDef="orderPoNumber">
          <th id="orderPoNumber" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ appStrings.invoiceDetails_poNumber }}
          </th>
          <td [id]="'orderPoNumber_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            {{ order.poNumber ? order.poNumber : appStrings.NA }}
          </td>
        </ng-container>
        <ng-container matColumnDef="orderStatus">
          <th id="orderStatus" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ appStrings.label_status }}
          </th>
          <td [id]="'orderStatus_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            {{ templateValuesResult.LnOrderStatus[order.statusCode] }}
          </td>
        </ng-container>
        <ng-container matColumnDef="orderTotalAmount">
          <th id="orderTotalAmount" mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">
            {{ appStrings.invoiceDetails_totalAmount }}
          </th>
          <td [id]="'orderTotalAmount_'+i" mat-cell *matCellDef="let order; let i = dataIndex" class="total">
            {{ order.total | currency: order.currencySign }}
          </td>
        </ng-container>
        <ng-container matColumnDef="orderQuoteNumber">
          <th id="orderQuoteNumber" mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">
            {{ appStrings.quote_quoteNumber }}
          </th>
          <td [id]="'orderQuoteNumber_'+i" mat-cell *matCellDef="let order; let i = dataIndex" class="total">
            {{ order.quoteNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="print">
          <th id="orderColumnsDefinitionPrint" mat-header-cell *matHeaderCellDef></th>
          <td [id]="'printCell_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            <ds-button size="medium" type="tertiary" variant="label-icon" icon="print-outlined"
              iconStyle="material-icons-outlined" [id]="'print_'+i" (onClick)="printOrder(order.orderNumber)"
              label="{{ appStrings.button_print }}" iconPosition="left">
            </ds-button>
          </td>
        </ng-container>
        <ng-container matColumnDef="view">
          <th id="orderColumnsDefinitionView" mat-header-cell *matHeaderCellDef></th>
          <td [id]="'viewCell_'+i" mat-cell *matCellDef="let order; let i = dataIndex">
            <a [id]="'viewOrder_' + i" [routerLink]="['/ln-orders', order.orderNumber, { customerId: customerId }]">
              <ds-button size="medium" type="tertiary" variant="label-icon" icon="visibility-outlined"
                iconStyle="material-icons-outlined" [id]="'view_'+i" label="{{ appStrings.button_view }}"
                iconPosition="left">
              </ds-button>
            </a>
          </td>
        </ng-container>
      </ds-table>
    </div>

    @if (!totalRecords && !isLoading && !isPartialLoading) {
      <div id="emptyOrdersList" class="no-results">
        {{ appStrings.noEntriesFound }}
      </div>
    }
    @if (isPartialLoading) {
      <div id="loadingPartialResults" class="searching-row row-loading">
        <span id="hourglassLoading" class="crm-industrial-font icon-hourglass"></span>
        {{ appStrings.loading_stillSearching }}
      </div>
    }

    @if (totalRecords) {
      <div id="paginationContainerDesktop" class="pagination-container-desktop">
        <div id="pageCount" class="page-count">
          @if (!isLoading && !isPartialLoading) {
            <div id="pageCountText">
              <b>{{ pageOffset + 1 }} - {{ pageOffset + (orderList?.length ?? 0) }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
            </div>
          }
        </div>
        <div id="lnOrdersListPaginator">
          <ds-pagination
            [totalPages]="totalPages"
            paginationDisplay="large"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
        <div class="flex-item-2"></div>
      </div>
    }
  </ds-paper>
</div>

<!-- Mobile View -->
<div *appIsMobile id="lnOrdersMainContainer-mobile" class="mobile">
  @if (isLoading) {
    <div class="overlay full" id="lnOrders-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  @if (dataLoaded.templateValues) {
    <app-quotes-subsections-filter-form (resetSort)="resetSortIndicator($event)"
      (resetPage)="resetPageIndex()" [getListMethod]="getListMethod" [sortKey]="lnOrderKey"
      [label]="appStrings.menu_lnOrders" [isOnAccountsPage]="isOnAccountsPage"
      [bpNumber]="bpNumber" [lnOrderTemplates]="templateValuesResult" [activeTab]="activeTab.LNOrders">
    </app-quotes-subsections-filter-form>
  }

  @for (order of orderList; track order; let i = $index) {
    <mat-expansion-panel [id]="'lnOrderCard_'+i" class="mobile-card two-columns tall blue-border" [expanded]="false">
      <mat-expansion-panel-header [id]="'lnOrderCardHeader_'+i">
        <mat-panel-title id="lnOrder-card-header-container" class="card-header-container">
          <span [id]="'lnOrder-card-header_'+i" class="card-header">
            <span [id]="'lnOrder-card-title_'+i" class="title">
              {{ order.accountName ?? '-'}}
            </span>
            <span [id]="'lnOrder-card-subtitle_'+i" class="subtitle">
              {{ order.total | currency: order.currencySign }}
            </span>
          </span>
          <span [id]="'lnOrder-card-header-action_'+i" class="card-header-action">
            <a [id]="'viewCell_' + i" [routerLink]="['/ln-orders', order.orderNumber, { customerId: customerId }]">
              <ds-button size="medium" type="tertiary" variant="icon-only" icon="visibility-outlined"
                iconStyle="material-icons-outlined" [id]="'view_' + i">
              </ds-button>
            </a>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ds-divider></ds-divider>
      <div [id]="'lnOrderCardContent_'+i" class="content">
        <div [id]="'lnOrderCardRow1_'+i" class="row">
          <div [id]="'lnOrderCardRow1Col1_'+i" class="column">
            <typography [id]="'orderDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.invoiceDetails_salesRepresentative }} </typography>
            <typography [id]="'orderDate_'+i" variant="body-2" weight="medium"> {{ order.accountManagerName }} </typography>
          </div>
          <div [id]="'lnOrderCardRow1Col2_'+i" class="column">
            <typography [id]="'orderStatus_label_'+i" class="label" variant="caption-2" weight="regular">{{ appStrings.orderDetails_orderNumber }}</typography>
            <typography [id]="'orderStatus_'+i" variant="body-2" weight="medium"> {{  order.orderNumber }} </typography>
          </div>
        </div>
        <div [id]="'lnOrderCardRow2_'+i" class="row">
          <div [id]="'lnOrderCardRow2Col1_'+i" class="column">
            <typography [id]="'orderDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.orderDetails__orderDate }} </typography>
            <typography [id]="'orderDate_'+i" variant="body-2" weight="medium"> {{ order.orderDate | date: dateFormat }} </typography>
          </div>
          <div [id]="'lnOrderCardRow2Col2_'+i" class="column">
            <typography [id]="'orderStatus_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_status }} </typography>
            <typography [id]="'orderStatus_'+i" variant="body-2" weight="medium"> {{ templateValuesResult.LnOrderStatus[order.statusCode] }} </typography>
          </div>
        </div>
        <div [id]="'lnOrderCardRow3_'+i" class="row">
          <div [id]="'lnOrderCardRow3Col1_'+i" class="column full-width">
            <typography [id]="'orderPoNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.invoiceDetails_poNumber }} </typography>
            <typography [id]="'orderPoNumber_'+i" variant="body-2" weight="medium"> {{ order.poNumber ? order.poNumber : appStrings.NA }} </typography>
          </div>
        </div>
        <div [id]="'lnOrderCardRow4_'+i" class="row">
          <div [id]="'lnOrderCardRow4Col1_'+i" class="column full-width">
            <typography [id]="'orderQuoteNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quote_quoteNumber }} </typography>
            <typography [id]="'orderQuoteNumber_'+i" variant="body-2" weight="medium"> {{ order.quoteNumber }} </typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <div [id]="'lnOrderCardActions_'+i" class="card-actions">
        <ds-button size="medium" type="secondary" variant="label-icon" icon="print" iconStyle="material-icons-outlined" [id]="'print_'+i"
          (onClick)="printOrder(order.orderNumber)" label="{{ appStrings.button_print }}" iconPosition="left">
        </ds-button>
      </div>
    </mat-expansion-panel>
  }
  @if (totalRecords > 0) {
    <div id="paginationContainerMobile" class="pagination-container">
      <ds-paper id="lnOrderListMobilePaginationPaper" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
        <div id="mobilePagination" class="pagination">
          <ds-pagination
            [totalPages]="totalPages"
            paginationDisplay="small"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
      </ds-paper>
    </div>
  }
  @if (!totalRecords && !isLoading && !isPartialLoading) {
    <div id="emptyLnOrdersList" class="no-results">
      {{ appStrings.noEntriesFound }}
    </div>
  }
</div>
